<template>
  <div>
    <a-row>
      <a-col :span="8">
        <a-descriptions :column="1" class="simiot-descriptions">
          <a-descriptions-item label="入库批次">{{ batchOperationRecordInfo.operation_no }}</a-descriptions-item>
          <a-descriptions-item label="入库时间">{{ batchOperationRecordInfo.created_at }}</a-descriptions-item>
          <a-descriptions-item label="入库人">{{ batchOperationRecordInfo.operator_name }}</a-descriptions-item>
          <a-descriptions-item label="入库总数">{{ batchOperationRecordInfo.operation_count }}</a-descriptions-item>
          <a-descriptions-item label="入库成功数">{{ batchOperationRecordInfo.success_count }}</a-descriptions-item>
          <a-descriptions-item label="入库失败数">{{ batchOperationRecordInfo.failure_count }}</a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="8">
        <a-descriptions :column="1" class="simiot-descriptions">
          <a-descriptions-item label="供应商">{{ batchOperationRecordInfo.profile_supplier_name }}</a-descriptions-item>
          <a-descriptions-item label="PRP规则">{{ batchOperationRecordInfo.prp_id_text }}</a-descriptions-item>
          <a-descriptions-item label="状态">{{ batchOperationRecordInfo.status_text }}</a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="8">
        <a-descriptions :column="1" class="simiot-descriptions">
          <a-descriptions-item label="Profile费">{{ batchOperationRecordInfo.profile_fee }}</a-descriptions-item>
          <a-descriptions-item label="总Profile费">{{ batchOperationRecordInfo.total_profile_fee }}</a-descriptions-item>
          <a-descriptions-item label="重跑次数">{{ batchOperationRecordInfo.run_times }}</a-descriptions-item>
          <a-descriptions-item label="备注">
            <span class="batch-operation-record-info">{{ batchOperationRecordInfo.remark }}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
    <a-row>
      <a-col>
        <span>注：执行批量 Profile 入库时，单个失败不影响其他 ICCID 入库，但批次结果可能为失败。</span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'BatchOperationRecordProfilesImportInfo',
  props: {
    batchOperationRecordInfo: { type: Object, required: true }
  }
}
</script>
